export default "__VITE_ASSET__BDXFsPGy__"